import React from 'react'
import PropTypes from 'prop-types';
import { Headline1 } from '@cdm/quickenloans-library/lib'
import { heroWithTitle, titleContainer, subtitleContainer, pageContent } from './GenericPageWithTitle.module.scss';

const GenericPageWithTitle = ({ title, children, className, subtitle, testId = "", prevSection }) =>
    <div className={`QLD_ROOT ${className ? className : ''}`} data-testid={testId}>
        <div className={heroWithTitle} data-testid='hero-with-title'>
            <div className='qld-grid'>
                <div className={`qld-row ${titleContainer}`}>
                    <Headline1 testId='hero-title' className='h1_black_newSize'>
                        {title}
                    </Headline1>
                </div>
                {subtitle && <span className={`qld-row ${subtitleContainer}`}>{subtitle}</span>}
            </div>
        </div>
        {prevSection ? prevSection : null}
        <section className={`${pageContent} qld-grid`}>
            {children}
        </section>
    </div >

GenericPageWithTitle.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]).isRequired,
    subtitle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    testId: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object,
        PropTypes.string
    ])),
    prevSection: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    className: PropTypes.string,
}

export default GenericPageWithTitle;
